import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.CopyWorkflowPopup.SingleResultPopup', {
    successfulMessage: ' has been successfully copied to ',
    existingRequestsNode:
        'Please note that the updated workflow does not automatically apply to past existing requests.',
    activateWorkflow: "Don't forget to activate your workflow!",
    done: 'Done',
});
